import React, { memo } from 'react';
const screenshots = [{
  src: 'https://cdn.magicpatterns.com/uploads/2jsUyyv3Anah6TX3UVkuJU/Spatial_reasoning_meets_LLMs1.png',
  alt: 'Copilot route selection — scenic route to Chicago Riverwalk with route summary'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vDuYpCtPNH5kbtjTs5pg5h/Spatial_reasoning_meets_LLMs2.png',
  alt: 'Copilot turn-by-turn reasoning — why this route, segment-by-segment walkthrough'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ov1HQJfTA4vTXjn6SbQS1b/Spatial_reasoning_meets_LLMs3.png',
  alt: 'Copilot live street cues — real-time contextual callouts during navigation'
}];
export function AppendixLLMSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-94">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden" data-id="element-95">
        {/* Header */}
        <div className="flex-shrink-0 flex flex-col" style={{
        padding: 'clamp(1.5rem, 3vw, 2.5rem) var(--slide-padding) 0'
      }} data-id="element-96">
          <div className="flex items-baseline gap-4 mb-[clamp(0.3rem,0.6vw,0.5rem)] animate-fade-slide" style={{
          animationDelay: '0.1s'
        }} data-id="element-97">
            <p className="italic font-semibold" style={{
            color: '#4A90D9',
            fontSize: 'var(--body-size)'
          }} data-id="element-98">
              Experiment 03
            </p>
            <h2 className="font-black tracking-tight text-white leading-[1.1]" style={{
            fontSize: 'var(--h2-size)'
          }} data-id="element-99">
              Turn-by-turn copilot
            </h2>
          </div>
          <p className="text-white/50 leading-relaxed animate-fade-slide max-w-4xl" style={{
          fontSize: 'var(--body-size)',
          animationDelay: '0.2s'
        }} data-id="element-100">
            An AI copilot that walks with you — explaining why each route was
            chosen, surfacing street cues in real time, and adapting guidance to
            your preferences and surroundings.
          </p>
        </div>

        {/* Screenshots — 3 side by side, natural size */}
        <div className="flex-1 flex items-center justify-center min-h-0 overflow-hidden" style={{
        padding: 'clamp(0.75rem, 1.5vw, 1.25rem) var(--slide-padding) clamp(1.5rem, 3vw, 2.5rem)',
        gap: 'clamp(0.75rem, 1.5vw, 1.5rem)'
      }} data-id="element-101">
          {screenshots.map((s, i) => <div key={i} className="animate-fade-slide flex items-center justify-center h-full" style={{
          animationDelay: `${0.3 + i * 0.1}s`
        }} data-id="element-102">
              <img src={s.src} alt={s.alt} style={{
            maxHeight: '100%',
            width: 'auto',
            objectFit: 'contain',
            borderRadius: 'clamp(12px, 2vw, 24px)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08)'
          }} data-id="element-103" />
            </div>)}
        </div>
      </div>
    </section>;
}